import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert/alert.service';
import { AreaService } from 'src/app/services/area.service';

@Component({
  selector: 'app-new-area',
  templateUrl: './new-area.component.html',
  styleUrls: ['./new-area.component.css']
})
export class NewAreaComponent implements OnInit {

  form: FormGroup = new FormGroup({});

  constructor(
    public dialogRef: MatDialogRef<NewAreaComponent>, 
    @Inject(MAT_DIALOG_DATA) public data:any, 
    private formBuilder: FormBuilder, 
    private areaService: AreaService,
    private alert: AlertService
  ) { }

  ngOnInit(): void {
    this.cargarFormulario();
    if (this.data) {
      this.cargarDatos();
    }
  }

  cargarDatos() {
    this.form.reset({
      nombre: this.data.name,
      descripcion: this.data.description
    });
  }

  cargarFormulario() {
    this.form = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]]
    });
  }

  guardar() {
    if (this.form.invalid) {
      this.alert.showInfo("invalid");
      return;
    }

    const formData = new FormData();
    formData.append('name', this.form.value.nombre);
    formData.append('description', this.form.value.descripcion);

    this.areaService.postArea(formData)
      .subscribe((res: any) => {
        if (res.data.status !== 200) {
          this.alert.showErrorCustom(res.data.mensaje);
          return;
        }
        else {
          this.alert.showSave('ok');
          this.dialogRef.close(true);
        }
      },
      (err: any) => {
        this.alert.showSave('error');
      });
  }

  actualizar() {
    if (this.form.invalid) {
      this.alert.showInfo("invalid");
      return;
    }
    
    let datos = {
      name: this.form.value.nombre,
      description: this.form.value.descripcion
    };
    this.areaService.putArea(this.data.id, datos)
      .subscribe((res: any) => {
        if (res.data.status !== 200) {
          this.alert.showErrorCustom(res.data.mensaje);
          return;
        }
        this.alert.showUpdate("ok");
        this.dialogRef.close(true);
      },
      (err: any) => {
        this.alert.showUpdate("error");
      });
  }

}
